export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Home',
    garage: 'Garage Systems',
    villa: 'Villa Projects',
    winter: 'Winter Garden',
    projects: 'Projects',
    about: 'About Us',
    contact: 'Contact',
    dealer: 'Dealership & Partnership',
    login: 'Member / Dealer Login',
    cta: 'Get a Quote for Your Project',
  },
  hero: {
    title1: 'Premium Garage Systems',
    title2: 'That Add Value to Your Villa',
    subtitle: 'Architecturally tailored premium enclosed garage solutions for luxury villa projects and private villas.',
    cta1: 'Get a Quote for Your Project',
    cta2: 'Explore Garage Systems',
    small: '1 & 2 Car Systems • Custom Architectural Design • Project-Based Solutions',
  },
  s1: {
    title: 'A Garage Should Not Be an Afterthought to Your Villa.',
    text: 'VILLAGARAGE treats the garage not as a standalone structure, but as an integral part of the villa’s architecture.',
    f1: 'Architecturally tailored design',
    f2: 'Premium appearance',
    f3: 'All-season vehicle protection',
  },
  s2: {
    title: 'Same Villa. A Different Standard of Living.',
    openTitle: 'Open Parking',
    openDesc: 'Vehicle exposed to the elements. Lacks architectural integrity. Adds no value to the project.',
    garageTitle: 'VILLAGARAGE Premium Garage',
    garageDesc: 'Vehicle protected all year. Integrates with the villa’s architecture. Adds premium value to the project.',
    cta: 'Request a Solution for Your Project',
  },
  s3: {
    title: 'Garage Systems',
    cta: 'Explore',
    card1: {
      title: 'Single-Car Premium Garage',
      desc: 'A compact, elegant, architecturally tailored premium garage for a single vehicle.',
    },
    card2: {
      title: 'Double-Car Premium Garage',
      desc: 'A spacious, airy premium garage that integrates seamlessly with your villa for two vehicles.',
    },
    card3: {
      title: 'Project-Specific Garage Systems',
      desc: 'Bespoke solutions designed around villa projects and unique requirements.',
    },
  },
  s4: {
    title1: 'No Two Villas Are Alike.',
    title2: 'Neither Should Their Garages Be.',
    d1: 'Anthracite architectural systems',
    d2: 'Natural wood details',
    d3: 'Architectural lighting',
    d4: 'Custom facade designs',
    d5: '1 & 2 car solutions',
  },
  s5: {
    title: 'A Detail That Sets Villa Projects Apart',
    subtitle: 'VILLAGARAGE for construction companies, project developers, and architects.',
    b1: 'Project-specific design',
    b2: 'Integration with villa architecture',
    b3: 'Structure suited to multi-villa projects',
    b4: 'Premium project perception',
    b5: 'Single / double car solutions',
    b6: 'A systems approach as an alternative to traditional heavy construction',
    cta: 'Submit Your Villa Project',
  },
  s6: {
    title: 'Don’t Leave Your Million-Dollar Car Exposed All Year.',
    text: 'Create a more protected premium space against sun, rain, hail, snow, and external factors.',
    cta: 'I Want a Garage for My Villa',
  },
  s7: {
    title: 'Holistic Architectural Solutions for Your Villa',
    subtitle: 'Premium Garage + Winter Garden',
    cta: 'Request Information for My Project',
  },
  s8: {
    title: 'How Does Your Project Begin?',
    step1: 'Share Your Space',
    step1d: 'Send us the essential details about your villa or project.',
    step2: 'Define the Need',
    step2d: 'Let’s clarify vehicle capacity and usage scenarios together.',
    step3: 'Design Approach',
    step3d: 'Let’s develop a bespoke design approach suited to your architecture.',
    step4: 'Quote',
    step4d: 'Let’s provide you with a tailored quote based on project scope.',
    step5: 'Implementation',
    step5d: 'After approval, let’s carry out the implementation as planned.',
  },
  s9: {
    title: 'Inspiring Garage Projects',
    filterAll: 'All',
    filterSingle: 'Single-Car',
    filterDouble: 'Double-Car',
    filterVilla: 'Villa Projects',
    filterWinter: 'Winter Garden',
  },
  s10: {
    title: 'Let’s Design a Custom Solution for Your Villa or Project.',
  },
  form: {
    name: 'Full Name',
    namePh: 'Your full name',
    phone: 'Phone',
    phonePh: '+90 5xx xxx xx xx',
    email: 'Email',
    emailPh: 'example@email.com',
    city: 'City',
    cityPh: 'Your city',
    customerType: 'Customer Type',
    solution: 'Solution You’re Interested In',
    projectStatus: 'Project / Land Status',
    message: 'Message',
    messagePh: 'Briefly describe your project...',
    upload: 'Image Upload',
    uploadHint: 'You can upload land, villa, or reference images',
    submit: 'SUBMIT MY PROJECT',
    success: 'Your request has been received. We will contact you shortly.',
    error: 'Something went wrong. Please try again.',
    customer: {
      villaOwner: 'Villa Owner',
      construction: 'Construction Company',
      developer: 'Project Developer',
      architect: 'Architect',
      investor: 'Investor',
      other: 'Other',
    },
    solutionOpt: {
      single: 'Single-Car Garage',
      double: 'Double-Car Garage',
      villaProject: 'Villa Project',
      winterGarden: 'Winter Garden',
      combined: 'Garage + Winter Garden',
      custom: 'Custom Project',
    },
    status: {
      land: 'Have land / plot',
      construction: 'Villa under construction',
      existing: 'Existing villa',
      none: 'No land yet',
      other: 'Other',
    },
  },
  whatsapp: {
    message: 'Hello VILLAGARAGE, I would like to get information and a quote for my villa / garage project.',
  },
  mobile: {
    cta: 'Request Information for Your Project',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'Can it be applied to existing villas?',
    a1: 'Yes. We offer solutions suited to both newly built and existing villas. For existing villas, a project-specific implementation is carried out after assessing the space and architectural structure.',
    q2: 'Are single and double car systems available?',
    a2: 'Yes, our single-car and double-car premium garage systems are available. We also develop project-specific multi-solutions.',
    q3: 'Is the same model applied to every villa?',
    a3: 'No. Each project is custom-designed according to the villa’s architecture, dimensions, and the client’s needs; no standard model is used.',
    q4: 'Do you work on multi-villa projects?',
    a4: 'Yes, we work with construction companies and project developers on multi-villa projects, offering project-based custom solutions.',
    q5: 'Can a winter garden also be built?',
    a5: 'Yes. In addition to garage systems, we offer winter garden and integrated garage + winter garden solutions.',
    q6: 'How is pricing determined?',
    a6: 'Pricing is determined based on dimensions, vehicle capacity, architectural details, material preferences, and project scope.',
    q7: 'How can I submit my project?',
    a7: 'You can fill out the form on our website, reach us via WhatsApp (+90 542 799 47 89), or send a message via Instagram (@villagarage90).',
  },
  about: {
    title: 'About Us',
    text: 'VILLAGARAGE is a brand that develops architectural solutions for premium villa garages and outdoor living spaces. It treats the garage not as a standalone structure but as an integral part of the villa’s architecture, adding lasting value to living spaces through anthracite systems, natural wood details, and custom facade designs. Working with villa owners, architects, contractors, and project developers, it delivers premium solutions tailored to every need and integrated with the architecture.',
  },
  final: {
    title: 'Complete Your Villa’s Architecture with Your Garage.',
    cta1: 'Get a Quote for Your Project',
    cta2: 'Contact Us on WhatsApp',
  },
  roles: {
    member: 'Regular Member',
    dealer_a: 'Class A Dealer',
    dealer_b: 'Class B Dealer',
    dealer_c: 'Class C Dealer',
    distributor: 'Distributor',
    architect: 'Architect',
    construction: 'Construction Company',
    realtor: 'Realtor',
    admin: 'Administrator',
  },
  catalog: {
    title: 'Garage Systems',
    all: 'All',
    cat: {
      standard: 'Standard Garages',
      custom: 'Custom Design Garages',
      luxury: 'Luxury Garages',
    },
    tag: {
      new: 'New',
      single: 'Single-Car',
      double: 'Double-Car',
      premium: 'Premium',
      project: 'Project-Specific',
    },
    capacityLabel: 'Vehicle Capacity',
    singleCar: '1 Car',
    doubleCar: '2 Cars',
    multiCar: 'Multiple Cars',
    quote: 'Get a Quote',
    details: 'Details',
    addToCart: 'Add to Cart',
    projectQuote: 'Create a Project-Specific Quote',
    from: 'From',
    priceOnRequest: 'Request a quote for pricing',
    empty: 'No products in this category yet.',
    p1: { desc: 'A compact, elegant, architecturally tailored premium garage for a single vehicle.' },
    p2: { desc: 'A spacious, airy premium garage that integrates seamlessly with your villa for two vehicles.' },
    p3: { desc: 'A bespoke single-car garage designed specifically for your villa and integrated with its architecture.' },
    p4: { desc: 'A custom-designed, double-car architectural garage solution.' },
    p5: { desc: 'A luxury villa garage with the highest-grade materials and details.' },
    p6: { desc: 'Project-based custom garage systems for multi-villa developments.' },
  },
  currency: {
    label: 'Currency',
    planned: 'Soon',
  },
  auth: {
    title: 'Member / Dealer Login',
    subtitle: 'Access your role-specific panel and pricing.',
    email: 'Email',
    password: 'Password',
    submit: 'Sign In',
    note: 'Secure sign-in and role-based authorization will be active once the backend connection is completed.',
    comingSoon: 'The sign-in layer is ready. This screen will become active once the secure backend connection is completed.',
    roleInfoTitle: 'Role-Based Access',
    roleInfoText: 'Regular member, Class A/B/C dealers, distributor, architect, construction company, realtor and administrator roles are supported. Each role only sees the areas it is authorized for; authorization is enforced server-side.',
    applyCta: 'Apply for Dealership & Partnership',
    backHome: 'Back to Home',
  },
  dealer: {
    badge: 'Partnership Network',
    heroTitle: 'Join the VILLAGARAGE Partnership Network',
    heroSubtitle: 'Bring VILLAGARAGE premium garage systems to your clients across Turkey and international markets.',
    heroCta: 'Apply Now',
    modelsTitle: 'Membership & Dealership Models',
    modelsSubtitle: 'A structure for every level, from individual clients to professional dealers.',
    cardCta: 'Detailed Info & Application',
    models: {
      standard: { name: 'Standard Membership', desc: 'Base membership for individual clients and regular members.' },
      a: { name: 'Class A Dealership', desc: 'The most comprehensive dealership model. Discounts, quota, deposit and payment advantages are set by the administrator.' },
      b: { name: 'Class B Dealership', desc: 'A balanced partnership model for mid-scale dealers.' },
      c: { name: 'Class C Dealership', desc: 'An entry-level partnership model for new dealers.' },
    },
    proTitle: 'Professional Partnership',
    proSubtitle: 'A flexible partnership model for professionals who refer projects and clients.',
    proSectors: 'Architects • Construction Companies • Realtors • Distributors',
    partnerCta: 'Become a Partner',
    partnersTitle: 'Partner Models',
    partners: {
      distributor: 'Distributor',
      architect: 'Architect',
      construction: 'Construction Company',
      realtor: 'Realtor',
      other: 'Other Partner',
    },
    partnersNote: 'With no dealer quota or deposit; each group receives its own discount, pricing advantage and permission level.',
    termsTitle: 'Class-Specific Terms',
    termsText: 'Discount rates, purchase quotas, deposit amounts and payment advantages are defined separately for each dealership class and managed from the admin panel. These values are not fixed at this time.',
    rolesTitle: 'Role Structure',
    rolesSubtitle: 'Each user only sees the areas allowed by their role; authorization is enforced server-side once a secure backend is connected.',
    form: {
      title: 'Application Form',
      subtitle: 'Fill in the form below; your application will be received for evaluation.',
      name: 'Full Name',
      company: 'Company Name',
      phone: 'Phone',
      email: 'Email',
      country: 'Country',
      city: 'City',
      website: 'Website',
      instagram: 'Instagram',
      field: 'Field of Activity',
      applicationType: 'Application Type',
      selectPlaceholder: 'Select',
      howToWork: 'How would you like to work with VILLAGARAGE?',
      messagePh: 'Tell us briefly...',
      submit: 'Submit My Application',
      success: 'Your application has been received for evaluation.',
      error: 'Something went wrong. Please try again.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menu',
    contactTitle: 'Contact',
    instagram: 'Instagram',
    copyright: 'All rights reserved.',
  },
};